import { Pipe, PipeTransform } from '@angular/core';
import { Jsonp } from '@angular/http';
import { map, tap } from 'rxjs/operators';
import { UtilitiesProvider } from '../providers/utilities';
@Pipe({
  name: 'fromApi'
})

export class FromApiPipe implements PipeTransform {

  constructor(
    private jsonp: Jsonp,
    private utilities: UtilitiesProvider
  ) { }

  transform(value: string): any {
    return this.jsonp.get(value).pipe(
      tap((res) => this.utilities.consoleDecorator('Result', res)),
      map(res => res.json()
      ));
  }
}


// WEBPACK FOOTER //
// ./src/pipes/from-api.pipe.ts